import { render, staticRenderFns } from "./CustomerPageTrainingCard.vue?vue&type=template&id=249181a1&"
import script from "./CustomerPageTrainingCard.vue?vue&type=script&lang=js&"
export * from "./CustomerPageTrainingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports